import { Injectable } from '@angular/core';
import {StaticMethods} from '../model/GeneralModels';
import {AuthService} from './auth.service';
import {HttpClientWrapperService} from '../config/http-client-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class FinanceService {

  constructor(private authService: AuthService,
              private http: HttpClientWrapperService) { }

  invoice(requestID: number, productName: string, discountCode: string, paymentMode: string, paymentPort?: string) {
    discountCode = discountCode ? '&discountCode=' + discountCode : '';
    // tslint:disable-next-line:max-line-length
    return this.http.get(`common/${productName}/inVoice?requestID=${requestID}${discountCode}&multi=0&paymentMode=${paymentMode}${paymentPort ? `&paymentPort=${paymentPort}` : ``}`, this.authService.decode().auth);
  }

  B2BPaymentCallback(productName: string, resNum: number, amount: number) {
    return this.http.post(`common/callback`, {
      res_num: resNum,
      amount
    }, this.authService.decode().auth);
  }

  zarinPalPaymentCallback(params: any, baseUrl: string) {
    const data = {
      Authority: params.Authority,
      Status: params.Status
    };
    return this.http.post(`common/callback`, data, this.authService.decode().auth);
  }
}
